import { reportedNumber } from "@/utilities/reportedNumber";

/**
 * A number an entity reported, treating zero as "not reported".
 *
 * Specific to the fuel entities, which is why it lives here rather than beside
 * {@link reportedNumber}: `FuelTransaction.odometer` and `FuelEvent.volume` are documented
 * `Default [0]`, so a transaction where the driver keyed in nothing arrives as a zero rather than
 * as an absent value. Read literally, a fill-up then shows an odometer of 0 km and a volume of
 * 0 l, and, worse, the zero counts as a reported value and blocks the fallback that would have
 * filled it in. Neither figure is meaningful at zero, so zero is read as silence.
 *
 * @param value - The value as it came off the entity.
 */
export function reportedNonZero(value: number | undefined | null): number | null {
  const number = reportedNumber(value);
  return number === 0 ? null : number;
}
